import { createFileRoute } from "@tanstack/react-router";
import heroImg from "@/assets/junk.jpg";
import { ServicePage } from "@/components/ServicePage";
import { services } from "@/lib/service-content";
import { faqJsonLd, serviceJsonLd, breadcrumbJsonLd } from "@/lib/site";

export const Route = createFileRoute("/eviction-cleanouts")({
  head: () => ({
    meta: [
      { title: services["eviction-cleanouts"].metaTitle },
      { name: "description", content: services["eviction-cleanouts"].metaDescription },
      { property: "og:title", content: services["eviction-cleanouts"].metaTitle },
      { property: "og:description", content: services["eviction-cleanouts"].metaDescription },
      { property: "og:url", content: "https://anchorsrq.com/eviction-cleanouts" },
    ],
    links: [{ rel: "canonical", href: "https://anchorsrq.com/eviction-cleanouts" }, { rel: "preload", as: "image", href: heroImg, fetchpriority: "high" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(breadcrumbJsonLd([{ name: 'Home', url: 'https://anchorsrq.com/' }, { name: 'Services', url: 'https://anchorsrq.com/#services' }, { name: 'Eviction Cleanouts', url: 'https://anchorsrq.com/eviction-cleanouts' }])) },
      { type: "application/ld+json", children: JSON.stringify(serviceJsonLd({ slug: "eviction-cleanouts", name: 'Eviction Cleanouts', serviceType: 'Eviction Cleanout', description: 'Discreet, court-ready eviction cleanouts for Sarasota-area landlords and property managers — left-behind belongings handled per Florida statute by the Anchor Services crew.' })) },
      { type: "application/ld+json", children: JSON.stringify(faqJsonLd(services["eviction-cleanouts"].faqs)) },
    ],
  }),
  component: () => <ServicePage {...services["eviction-cleanouts"]} heroImg={heroImg} />,
});
